import { useState, useCallback } from 'react';
import axios from 'axios';
import logger from 'Core-utils/logger';
import { useContext } from 'react';
import { ToastsContext } from 'Rdx/contexts/ToastsContext';

export const useVideoCompletion = (hash: string | undefined) => {
    const { addToast } = useContext(ToastsContext);
    const [videoCompleted, setVideoCompleted] = useState(false);

    const markVideoCompleted = useCallback(async () => {
        if (!hash || videoCompleted) {
            return;
        }

        setVideoCompleted(true);
        try {
            const baseUrl = process.env.PLATFORM_API_URL || '';
            const response = await axios.post(
                `${baseUrl}/api/v1/trainings/${hash}/complete`,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.data?.success) {
                logger.log('Video completion posted successfully', response.data);
                addToast({
                    severity: 'success',
                    body: 'Training completed successfully!',
                });
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error: any) {
            logger.error('Failed to post video completion:', error);
            addToast({
                severity: 'error',
                body: error?.response?.data?.error || 'Failed to record training completion. Please contact support.',
            });
        }
    }, [hash, videoCompleted, addToast]);

    return { videoCompleted, markVideoCompleted };
};

